import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import "./Style/pages.css";
export default function Pages({ active, setActive, isEdit, setEdit }) {
  // Function to handle icon click and update the active state
  const handleClick = (iconName) => {
    setActive(iconName);
    setEdit(false);
  };

  return (
    <div className="pages">
      <Icon
        icon="uil:calender"
        className={`${active === "hero" ? "active" : ""} icon-p`}
        onClick={() => handleClick("hero")}
      />
      <Icon
        icon="ri:gift-2-line"
        className={`${active === "gift" ? "active" : ""} icon-p`}
        onClick={() => handleClick("gift")}
      />
      <Icon
        icon="hugeicons:ranking"
        className={`${active === "leader" ? "active" : ""} icon-p`}
        onClick={() => handleClick("leader")}
      />
      <Icon
        icon="iconamoon:profile-circle-fill"
        className={`${active === "profile" ? "active" : ""} icon-p`}
        onClick={() => handleClick("profile")}
      />
      <Icon
        icon="solar:settings-outline"
        className={`${active === "settings" ? "active" : ""} icon-p`}
        onClick={() => handleClick("settings")}
      />
    </div>
  );
}
